import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OfferFileService {

  constructor(private http: HttpClient) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getFiles(offerKey: number): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/OfferFile/${offerKey}`);
  }

  downloadFile(offerKey: number, offerFileKey: number): any {
    return this.http.get(`${environment.apiUrl}/OfferFile/${offerKey}/${offerFileKey}`, { observe: 'response', responseType: 'blob' });
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */



  uploadFiles(offerKey: number, files: any): Observable<any> {
    const formData = new FormData();

    for (const file of files) {
      formData.append('files', file);
    }

    return this.http.post(`${environment.apiUrl}/OfferFile/UploadFiles?offerKey=${offerKey}`, formData);
  }

  /* -------------------------------------------------------------------------- */
  /*                                   DELETE                                   */
  /* -------------------------------------------------------------------------- */

  deleteFile(offerKey: number, offerFileKey: number) {
    return this.http.delete(`${environment.apiUrl}/OfferFile/${offerKey}/${offerFileKey}`);
  }



  // download file docx
  downloadWordFile(url: string, filename: string) {
    this.http.get(url, { responseType: 'blob' }).subscribe((blob) => {
      const blobFile = new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blobFile);
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(link.href); // cleanup
    });
  }
}
